import axiosInstance from "./axiosInstance";

// Get all posts

export const fetchGold = async (data) => {
  const response = await axiosInstance.get("/user/get/gold", {
      params: data
    });
  return response.data;
};
export const fetchPlan = async (data) => {
  const response = await axiosInstance.get("/user/get/plan", {
      params: data
    });
  return response.data;
};
